import React, { FunctionComponent, useState } from 'react';
import { Button, TextArea, Icon, Input, Modal, Checkbox } from '@scuf/common';
import {  ERROR_MSG_FOR_USER_RESPONSE,  HAS_SCRIPT,  MAIL_SENT} from '../../../constants/constants';
import { IMoreContextModal } from '../../../models/IOpportunitiesAPIModel';
import { updateMoreContext } from '../../../services/UserAction';
import { getProfileDetails } from '../../..//services/Opportunities';
import { useAppDispatch } from '../../../store';
import { toast, ToastContent, Zoom } from 'react-toastify';
import { Snackbar } from '../../Snackbar/Snackbar';
import { AcceptToastTransition } from '../../Toasts/AcceptOppToast';
import { REQUEST_INPUT_TITLE, GET_CONTEXT_LEGAL_TEXT_DECLARATION, GET_CONTEXT_LEGAL_TEXT_NOTICE } from '../../../constants/constants';
import './../AcceptPopup.scss';
import { tagEvent, TAG_EVENT_CONST } from 'src/utils/analytics/analytics.service.util';
import { getMessage } from 'src/message/utils';
import DOMPurify from 'dompurify';
interface IAcceptPopup {
  onClose: Function;
  kpiId?: number;
  title?: string;
  textAreaTitle?: string;
  opportunityId: any;
  sendUserResponse?: Function;
  anomaly_id: string;
  sendingMailToatser: Function;
  activeAction: string
}
type ToastType =
  | 'accept'
  | 'reject'
  | 'realize'
  | 'claim-ownerShip'
  | 'more-context';

export const GetMoreContext: FunctionComponent<IAcceptPopup> = (props) => {
  const [enableRetryErr, setEnableRetryErr] = useState(false); // flag to enable submit button
  const [acceptActionInProgress, setacceptActionInProgress] = useState(false);
  const [btnText, setBtnText] = useState('Submit');
  const [comments, setComments] = useState('');
  //   const [validateEmail, setValidateEmail] = useState(false); //TODO: Unuseed state variable declartion
  const dispatch = useAppDispatch();
  const [emailItemData, setEmailItemData] = useState([] as any);
  const [value, setValue] = useState('');
  const [error, setError] = useState('');
  const [emailSuggestion, setEmailSuggestion] = useState([] as any);
  const [, setIsValidemail] = useState(false); // TODO: removed unused variable
  const [showRemarkError, setShowRemarkError] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorMessageFlag, setErrorMessageFlag] = useState(false);
  const [ldapLoader, setLdapLoader] = useState(false);
  const [checked, setChecked] = useState(false);
  const legalTextNotice = getMessage('app.anomalydetails.rightsection.legaltext')
  const warningText = getMessage('app.notes.footer.warning');

  const showActionToast = (toastContent: ToastContent, type: ToastType) => {
    if (type === 'reject' || type === 'realize') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'accept') {
      toast(toastContent, {
        className: 'fi-toast--accept',
        bodyClassName: 'fi-toast__body--accept',
        transition: AcceptToastTransition,
        closeOnClick: true,
      });
    } else if (type === 'more-context') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    } else if (type === 'claim-ownerShip') {
      toast(toastContent, {
        position: 'bottom-right',
        className: 'fi-toast--snackbar',
        bodyClassName: 'fi-toast__body--snackbar',
        transition: Zoom,
        closeOnClick: true,
      });
    }
  };
  const handleCommentsOnChange = (e: string) => {
    let inValidCharacter = /[<>()&#]/;
    if(inValidCharacter.test(e)){
      setShowRemarkError(true);
    }
    else{
      setComments(e);   
      setShowRemarkError(false);
    }   
  };

  const getMoreContext = () => {
    let eid: any = [];
    emailItemData.map((item: any) => eid.push(item.eid));
    setacceptActionInProgress(true);
    let inValidCharacter = /[<>()&#]/;

    let data: IMoreContextModal = {
      shareTo: eid,
      comment: comments,
      anomaly_id: props.anomaly_id,
    }; // @ts-ignore
    if(props.activeAction==="share-via-email"){
      delete data.comment;
      data.is_shared=true;
    }
    if (!inValidCharacter.test(comments)) {
      dispatch(updateMoreContext(props.opportunityId, data))
        .then((response: any) => {
          tagEvent(TAG_EVENT_CONST.share, {AnomalyId:props.opportunityId});
	  response.data.mail_status === MAIL_SENT ?
            props.sendingMailToatser('success', `${response.data.mail_status}`) :
            props.sendingMailToatser('failure', `${response.data.mail_status}`);
          setacceptActionInProgress(false);
          if (props.title === REQUEST_INPUT_TITLE) {
            showActionToast(
              <Snackbar toastMessage="Shared Successfully" />,
              'more-context'
            );
          } else {
            showActionToast(
              <Snackbar toastMessage="Anomaly successfully shared to get more context." />,
              'more-context'
            );
          }
          props.onClose();
        })
        .catch((error: any) => {
          setErrorMessage(error.response.data.message);
          setErrorMessageFlag(true);
          setEnableRetryErr(true);
          setacceptActionInProgress(false);
          setBtnText('Retry');
        });
    } else {
      setShowRemarkError(true);
      setacceptActionInProgress(false);
    }
  };

  const handleDelete = (email: string) => {
    let newEmailItemData = emailItemData.filter(
      (item: any) => item.email !== email
    );
    setEmailItemData(newEmailItemData);
    setError('');
  };

  const isInList = (email: string) => {
    let emailFound = emailItemData.filter((item: any) => item.email === email);
    return emailFound.length > 0 ? true : false;
  };


  const handleSearchChange = (val: string = '') => {
    setValue(val);
    setError('');
    if (val && val.length >= 3) {
      setLdapLoader(true);
      getProfileDetails(val).then((response: any) => {
        setEmailSuggestion(response);
        setLdapLoader(false);
      });
    } else if (val.length === 0) {
      setEmailSuggestion([]);
    }
  };

  const handleSearchSelect = (emailData: any) => {
    setEmailSuggestion([]);
    if (isInList(emailData.email)) {
      let error: any = null;
      error = (
        <div className="email-error">{`${emailData.email} has already been added`}</div>
      );
      setError(error);
      setIsValidemail(false);
      setEmailSuggestion([]);
      setValue('');
    } else if (emailItemData.length > 2) {
      let error: any = null;
      error = (
        <div className="email-error">{`Maximum 3 email can only be added`}</div>
      );
      setError(error);
      setIsValidemail(false);
      setEmailSuggestion([]);
      setValue('');
    } else {
      setEmailItemData([...emailItemData, emailData]);
      setValue('');
      setError('');
    }
  };

  return (
    <>
      {/* <Modal.Header>{props.title}</Modal.Header> */}
      <Modal.Content
        className={
          emailSuggestion && emailSuggestion.length > 0
            ? 'email-container'
            : 'right-morecontext-content'
        }
      >
        <div>
          <Input
            className="textbox textbox--enabled"
            value={value}
            placeholder="Search by EID, Email ID or FirstName.LastName"
            onChange={handleSearchChange}
            type="email"
            label="Email"
            indicator="required"
            fluid={true}
          />
          {ldapLoader && <p>Loading ■■■□□□</p>}
          <div>{error && <p className="input-email_error">{error}</p>}</div>
          <div
            className={
              value.length >= 3 && emailSuggestion && emailSuggestion.length > 0 ? 'input-email_wrapper' : ''
            }
          >
            {!ldapLoader && value.length >= 3 && emailSuggestion && emailSuggestion.length > 0 && emailSuggestion.map((emailData: any) => {
              return (
                <div
                  className="input-suggestions"
                  onClick={() => handleSearchSelect(emailData)}
                  key={emailData.id}
                >
                  <div className="input-suggestions_block">
                    <span>{emailData.last_name}</span>
                    <span className="input-suggestions-name">
                      {emailData.first_name}
                    </span>
                  </div>
                  <div className="input-suggestions_data">
                    {emailData.email}
                  </div>
                </div>
              );
            })}
            {!ldapLoader && value.length >= 3 && emailSuggestion && emailSuggestion.length === 0 && <p>No Records Found</p>}
          </div>
          <div className="badges-wrapper">
            {emailItemData.map((item: any) => (
              <div
                className="badges_block-email"
                data-testid="getMoreContext-span__badges"
                key={item.id}
              >
                {item.email}
                <span
                  className="badges_close-email"
                  onClick={() => handleDelete(item.email)}
                >
                  X
                </span>
              </div>
            ))}
          </div>
        </div>
        {(props.activeAction === "more-context" || props.activeAction === "share") &&
          <>
            <div className='email-error mt-3' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(warningText,{
                ALLOWED_ATTR:['href', 'target']
            }) }}></div>
            <TextArea
              onChange={handleCommentsOnChange}
              className="textarea-wrapper input-label-message textarea-fi"
              fluid={true}
              rows={2}
              placeholder={props.textAreaTitle}
              label="Comments"
              value={comments}
              required={true}
            />
            <Checkbox
              className="self-declare-checkbox checkbox-fi legal-text"
              data-testid='self-declare'
              label={GET_CONTEXT_LEGAL_TEXT_DECLARATION}
              checked={checked}
              disabled={emailItemData.length > 0 && Boolean(comments) ? false : true}
              onChange={(checked) => { setChecked(checked); }}
            />
            <div className='legal-text'>
              {legalTextNotice}
            </div>
          </>
        }
      </Modal.Content>
      {showRemarkError && (
        <div className="accept-popup__remarkerr">{HAS_SCRIPT}</div>
      )}

      <Modal.Footer className="getMorePopup__footer pop-footer">
        {enableRetryErr && errorMessage.length == 0 && (
          <div className="getMorePopup__footer--err err-msg">
            {ERROR_MSG_FOR_USER_RESPONSE}
          </div>
         )} 
        {errorMessageFlag && errorMessage.length > 0 && (
          <div className="getMorePopup__footer--err err-msg">{errorMessage}</div>
        )}
        <Button
          className="button--secondary button-space"
          data-testid="cancel"
          size="small"
          type="secondary"
          disabled={acceptActionInProgress}
          onClick={() => {
            props.onClose();
          }}
          content="Cancel"
        />
        <Button
          className={`button--primary ${acceptActionInProgress
            ? 'getMorePopup__footer--readonly btn-loading'
            : ''
            } button-space`}
          icon={
            enableRetryErr ? (
              <Icon
                root="building"
                name="refresh"
                exactSize={22}
                className="getMorePopup__footer--retry"
              />
            ) : (
              ''
            )
          }
          iconPosition="right"
          size="small"
          //   @ts-ignore
          disabled={(props.activeAction === "more-context" || props.activeAction === "share") ? ((emailItemData.length > 0 && Boolean(comments) && checked) ? false : true
          ) : emailItemData.length > 0 ? false : true
          }
          type="primary"
          data-testid="submit"
          onClick={getMoreContext}
          content={btnText}
        />
      </Modal.Footer>
    </>
  );
}